import React, {Component} from 'react'
import CSSModules from 'react-css-modules'
import styles from './chatTabs.css'
import ChatTabItem from './ChatTabItem'
import { PUBLIC_CHAT_ID, PRIVATE_CHAT_ID, TEAM_CHAT_ID } from '../../actions'

class ChatTabs extends Component {

  /*conponentDidMount(){
    this.props.changeChat(PRIVATE_CHAT_ID)
  }*/

   onClickTabs(tab) {
    this.props.changeChat(tab)
  }

  content() {
    const { role, workTeam } = this.props

    const privateTab = () => {
      return (
        <ChatTabItem
          onClickTabs={this.onClickTabs.bind(this)}
          tabName={PRIVATE_CHAT_ID}
          role={role}
          active={this.props.chat}
        >
          С тренером
        </ChatTabItem>
      )
    }
    const teamTab = () => {
      return (
        <ChatTabItem
          onClickTabs={this.onClickTabs.bind(this)}
          tabName={TEAM_CHAT_ID}
          role={role}
          active={this.props.chat}
        >
          С командой
        </ChatTabItem>
      )
    }
    return (
      <ul className={styles.chatTabs}>
        <ChatTabItem
          onClickTabs={this.onClickTabs.bind(this)}
          tabName={PUBLIC_CHAT_ID}
          role={role}
          active={this.props.chat}
        >
          Общий
        </ChatTabItem>
        {role === 2 || !workTeam ? null : teamTab()}
        {role === 2 ? null : privateTab()}
      </ul>
    )
  }

  render() {
    return (this.content())
  }
}

export default CSSModules(ChatTabs, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/Chat/ChatTabs.js